import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=c222433e&scoped=true"
import script from "./topics.vue?vue&type=script&lang=js"
export * from "./topics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c222433e",
  null
  
)

export default component.exports